import { render, staticRenderFns } from "./ComboManagement.vue?vue&type=template&id=56dd7131&scoped=true"
import script from "./ComboManagement.vue?vue&type=script&lang=js"
export * from "./ComboManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd7131",
  null
  
)

export default component.exports